module.exports = PageTop = function(el){
  this.element = $(el);
  this.win = $(window);
  this.doc = $(document);
  this.event();
};
PageTop.prototype.event = function(){
  var self = this;
  var visible = 'is-visible';
  this.win.on('scroll', function(){
    if($(this).scrollTop() > 200){
      self.element.addClass(visible);
    }else{
      self.element.removeClass(visible)
    }
  });
};



//////////////////
// WEBPACK FOOTER
// ./js/_modules/pageTop.js
// module id = 5
// module chunks = 0